import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { editLoan } from '../../features/loans/loanAPI';
import useEthers from '../../hooks/useEthers';
import Ex from '../../pages/ex/Ex';

function FundCard(loan) {
    const [showModal, setShowModal] = useState(false);
    const time = new Date(loan.createdAt).toISOString();
    const { switchNetwork, Transfer } = useEthers();
    const dispatch = useDispatch();

    const handleLend = async (e) => {
        e.preventDefault();
        const loanData = {
            _id: loan._id,
            repaymentAmount: loan.repaymentAmount,
            repaymentStatus: loan.repaymentStatus,
            loanStatus: 'Lent'
        };
        if (loan.loanStatus === 'Requested') {
            await switchNetwork(loan.block);
            const cdt = await Transfer(e, loan.borrowerWallet, loan.loanAmount.toString(), loan._id, loan.block, loan.coin);
            try {
                cdt && await dispatch(editLoan(loanData))
                    .unwrap()
                    .then(() => {
                        alert('Loan edited successfully');
                    })
                    .catch((error) => {
                        alert('Error editing loan:', error.message || error);
                    });
            }
            catch (error) {
                cdt && await dispatch(editLoan(loanData))
                    .unwrap()
                    .then(() => {
                        alert('Loan edited successfully');
                    })
                    .catch((error) => {
                        alert('Error editing loan:', error.message || error);
                    });
            }
        }
    };

    return (
        <article className="flex flex-col py-7 w-full bg-white rounded-3xl border border-solid border-neutral-200 shadow-[0px_2px_8px_rgba(0,0,0,0.25)] flex overflow-hidden flex-col py-8 bg-white rounded-2xl border border-solid border-zinc-300 max-w-[447px]">
            <header className="flex flex-col pr-16 pl-8 w-full">
                <div className="flex gap-1.5 items-center self-start text-base leading-loose whitespace-nowrap text-black text-opacity-60">
                    <span>{loan.borrowerUser}</span>
                    <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/fac88610c58d776106a83b2b5d5d859a63f1b01b52828bc85631e94bd9c14dbf?apiKey=e485b3dc4b924975b4554885e21242bb&" alt="" className="object-contain shrink-0 self-stretch my-auto aspect-[0.95] w-[21px]" />
                </div>
                <h2 className="mt-2.5 text-2xl font-medium leading-9 text-black">
                    {loan.reason}
                </h2>
            </header>
            <hr className="mt-5 w-full border border-solid border-zinc-300 min-h-[1px]" />
            {/* <div className="flex overflow-hidden gap-2.5 self-center p-4 mt-5 w-full text-sm leading-6 text-blue-900 rounded-lg bg-blue-600 bg-opacity-10 max-w-[387px]">
                <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/c2d360885d2f9813084ce3161772e6c5d54144310fdb2a5d99736f729b226dac?apiKey=e485b3dc4b924975b4554885e21242bb&" alt="" className="object-contain shrink-0 self-start w-6 aspect-square" />
                <p className="flex-auto w-[318px]">Recommended: USDT or USDC on Polygon, Arbitrum, or Base (lower fees).</p>
            </div> */}
            <div className="flex gap-10 items-center self-center mt-6">
                <div className="flex flex-col self-stretch my-auto whitespace-nowrap">
                    <div className="text-sm leading-loose text-black text-opacity-60">
                        Amount
                    </div>
                    <div className="mt-1.5 text-base leading-loose text-black">
                        ${loan.loanAmount}
                    </div>
                </div>
                <div className="flex flex-col self-stretch my-auto whitespace-nowrap">
                    <div className="text-sm leading-loose text-black text-opacity-60">
                        Payback
                    </div>
                    <div className="mt-1.5 text-base leading-loose text-black">
                        ${loan.repayedAmount}
                    </div>
                </div>
                <div className="flex flex-col self-stretch my-auto whitespace-nowrap">
                    <div className="text-sm leading-loose text-black text-opacity-60">
                        Repayment
                    </div>
                    <div className="mt-1.5 text-base leading-loose text-black">
                        {loan.days + " days (" + time.split("T")[0] + ")"}
                    </div>
                </div>
            </div>
            <hr className="mt-5 w-full border border-solid border-zinc-300 min-h-[1px]" />
            <div className="flex flex-col px-8 mt-5 w-full text-base">
                <h2 className="self-start text-lg font-medium leading-loose text-black">
                    Repayment Information
                </h2>
                <div className="flex overflow-hidden gap-10 p-4 mt-2.5 w-full whitespace-nowrap rounded-lg bg-neutral-100">
                    <div className="flex flex-1 gap-4 items-center">
                        <div className="self-stretch my-auto text-sm leading-loose text-black text-opacity-60">
                            Stablecoin
                        </div>
                        <div className="flex gap-1.5 items-center self-stretch my-auto text-base font-medium leading-loose text-black">
                            <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/36b2768ece14cc8c27f15df886baeb4d8561b26fdb09d2a7fd36f57790e94282?apiKey=e485b3dc4b924975b4554885e21242bb&" alt="" className="object-contain shrink-0 self-stretch my-auto w-7 aspect-square" />
                            <div className="self-stretch my-auto">{loan.coin}</div>
                        </div>
                    </div>
                    <div className="flex flex-1 gap-1.5 items-center self-start">
                        <div className="self-stretch my-auto text-sm leading-loose text-black text-opacity-60">
                            Network
                        </div>
                        <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/4ba089761d655b916ff23874ab3595e64d2f358d02957d03b3aaa8c77195070b?apiKey=e485b3dc4b924975b4554885e21242bb&" alt="" className="object-contain shrink-0 self-stretch my-auto w-6 aspect-square" />
                        <div className="self-stretch my-auto text-base font-medium leading-loose text-black">
                            {loan.block}
                        </div>
                    </div>
                </div>
                {/* <p className="leading-7 text-black">
                    Do you need to swap (any crypto) to stablecoin (suggested networks)?
                </p>
                <button className="overflow-hidden gap-5 self-stretch px-5 py-4 mt-4 leading-none text-center text-white rounded-lg bg-slate-900">
                    Swap Token Here
                </button>
                <div className="flex overflow-hidden gap-2.5 self-center p-4 mt-5 w-full text-sm leading-6 text-blue-900 rounded-lg bg-blue-600 bg-opacity-10 max-w-[387px]">
                    <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/c2d360885d2f9813084ce3161772e6c5d54144310fdb2a5d99736f729b226dac?apiKey=e485b3dc4b924975b4554885e21242bb&" alt="" className="object-contain shrink-0 self-start w-6 aspect-square" />
                    <p className="flex-auto w-[318px]">Funded wrong network? Contact support via dm3 for manual update.</p>
                </div>
                <div className="flex gap-2.5 items-center self-start mt-5 text-sm leading-loose text-black text-opacity-60">
                    <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/84e865e2f1d2492c63cf086ff64d258db65f82fcb1fbacf322a8af8941ebd886?apiKey=e485b3dc4b924975b4554885e21242bb&" alt="" className="object-contain shrink-0 self-stretch my-auto w-6 aspect-square" />
                    <span>Use current wallet for repayment</span>
                </div> */}
                <div className="flex gap-3 mt-5 w-full font-medium leading-none text-center">
                    {/* <button className="overflow-hidden gap-5 self-stretch p-5 whitespace-nowrap rounded-lg bg-neutral-100 text-black text-opacity-60">
                        Cancel
                    </button> */}
                    <button onClick={handleLend} className="overflow-hidden w-full gap-5 self-stretch p-5 text-white bg-blue-600 rounded-lg">
                        Fund Request
                    </button>
                </div>
                <p className="leading-7 text-black">
                    Do you need to swap (any crypto) to stablecoin (suggested networks)?
                </p>
                <button onClick={() => setShowModal(true)} className="overflow-hidden gap-5 self-stretch px-5 py-4 mt-4 leading-none text-center text-white rounded-lg bg-slate-900">
                    Swap Token Here
                </button>
                {showModal && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                    <button onClick={() => setShowModal(false)} className="text-gray-600 hover:text-gray-800 fixed top-4 right-4 z-50">
                        ✖
                    </button>
                    <Ex block={loan.block} coin={loan.coin} />
                </div>}
            </div>
        </article>
    );
}

export default FundCard;